import getFetcher from 'api/utils/getFetcher';
import { useMemo } from 'react';
import useSWR from 'swr';
import type { RouterCredentials } from 'types/legacyDashboard';

interface UseRouterCredentialsProps {
  organizationId?: OrgId;
  deviceId?: DeviceId;
}

export interface RouterCredentialsResult {
  success: boolean;
  data: Array<RouterCredentials>;
}

export interface RouterCredentialsResultError {}

const useRouterCredentials = ({ organizationId, deviceId }: UseRouterCredentialsProps) => {
  const queryParams = new URLSearchParams({ orgid: `${organizationId}`, deviceid: `${deviceId}` });
  const url = deviceId ? `${process.env.VITE_API_ROOT}/csr/sources?${queryParams}` : null;

  const { data, error, isLoading, isValidating, mutate } = useSWR<
    RouterCredentialsResult,
    RouterCredentialsResultError
  >(url, getFetcher);

  const allRouterCredentials: Array<RouterCredentials> = useMemo(() => data?.data ?? [], [data]);

  return {
    allRouterCredentials,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useRouterCredentials;
